export default "__VITE_ASSET__f3891c86__"